module.exports = __webpack_public_path__ + "img/flicker_bootom.fa87b466.gif";